import React, { Component } from 'react';
// import AnimatedWrapper from '../AnimatedWrapper'
import { pushEvent } from '../../utils/analytics.js';
import { triggerIntroReveal } from '../App';

import Title from '../../components/navigation/Title'
import Offline from '../../components/pageContent/Offline'

import Carousel from '../../components/carousel/Carousel'
import Loading from '../../components/pageContent/Loading'
import { getUrl } from '../../utils/services.js'

class Page extends Component {

	constructor(props) {

		super(props)

		this.state = {
			isLoading: false,
			isLoaded: false,
			data: {}
		}

		this.getData = this.getData.bind(this)

	}

	getData() {

		this.setState({
			isLoading: true
		})

		getUrl(`/api/landing`).then((data) => {

			// console.log(data)

			this.setState({
				data: data.fields,
				isLoading: false,
				isLoaded: true
			}, () => {
				// Signal that page is ready after state update and re-render
				if (this.props.onPageReady) {
					this.props.onPageReady();
				}
				// Also trigger intro reveal for first load
				triggerIntroReveal();
			})

		})

	}

	componentDidMount() {
		pushEvent();
		this.getData()
	}


	render() {


		const { data, isLoaded, isLoading } = this.state
		const { viewport, title, offline } = this.props

		const containerStyle = {
			// background: '#f6bbb8',
			minHeight: '100vh'
		}

		return (
			<div style={containerStyle}>

				{offline &&
					<Offline />
				}

				<Title text={title} />

				{isLoading &&
					<section aria-label="Loading content">
						<Loading />
					</section>
				}

				{isLoaded &&
					<section aria-label="Featured projects" style={{minHeight: '100vh'}}>
						<Carousel
							viewport={viewport}
							slides={data.featured}
						/>
					</section>
					// <div>test</div>
				}

			</div>
		);
	}
}

// const Wrapper = AnimatedWrapper(Page);
export default Page;